/* eslint-disable */

function getPrice(number) {
  let newLabel = '';
  let result = null;
  const numbers = (number + '').split('.');
  const arr = (numbers[0] + '').split('').reverse();

  arr.forEach((element, i) => {
    newLabel += element + ((i + 1) % 3 !== 0 || i === arr.length - 1 ? '' : ' ');
  });

  result = (newLabel + '').split('').reverse().join('');

  return numbers.length === 1 ? result : result + ',' + (numbers[1] + '').split('').slice(0, 2).join('');
}

function getNumber(text) {
  return isNumber(text) ? text : Number(text.split(',').join('.'));
}

function isNumber(val) {
  return !isNaN(val);
}

function initProducPrice() {
  const holder = jQuery('.product-info-form');

  if (!holder.length) return;

  holder.each((i, elem) => {
    const thisHolder = jQuery(elem);
    const inputPrice = thisHolder.find('[data-price]');
    const priceTarget = thisHolder.find('.price-js');

    function changeInputPrace() {
      const x = jQuery(this).val();
      const price = jQuery(this).data('price');

      priceTarget.text(getPrice(x * price));
    }

    inputPrice.on('change', changeInputPrace);
  });
}

export default function () {
  initProducPrice();
}
